/* eslint-disable */
var $ = window.jQuery = require('jquery');

import addNewUser from '@/components/private/add-new-user/';
import axios from 'axios';
import {bus} from '@/main';
import countries from '@/services/country.json'
import {mapGetters} from 'vuex';
import toast from '@/services/toast';
import trashUser from '@/components/trash-user/';

export default {
  name: 'author-user-create',
  components: {
    'add-new-user': addNewUser
  },
  props: [],
  data() {
    return {
      i: '',
      userList: null,
      name: '',
      submitted: false,
      userCreateform: false,
      totalCount: '',
      search: '',
      userListResults: [],
      is_active: Boolean,
      nextStep: '',
      loadmoreData: {},
      searchData: '',
      activeStatus: Boolean,
      userLoading: false,
      userSubscribeForm: false,
      selectedEmail: '',
      countryList: [],
      countryFilter: '',
      sortKey: '',
      sortNameDirection: 0,
      sortDateDirection: 0,
      authToken:'',
      apiEndpoint:'',
      userTrashId:'',
      email:''
    }
  },
  computed: {
    ...mapGetters([
      'getuserListDetailsState',

    ]),
    getUserList() {
      return this.userList = this.$store.getters.getuserListDetailsState.data
    },
    SetIntialStatus() {
      if (this.userList) {
        this.totalCount = this.userList.count
        this.nextStep = this.userList.next
        this.userListResults = this.userList.results
      }
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getUserList
    this.SetIntialStatus
    bus.$on('HideAddNewUserPopup', (data) => {
      this.userCreateform = data;
    });
    bus.$on('HideAddSubscriptionPopup', (data) => {
      this.userSubscribeForm = data;
    });
    console.log(process.env.VUE_APP_API_BASE_URL, 'fully data')
    this.authToken = localStorage.getItem('token')
    this.apiEndpoint = process.env.VUE_APP_API_BASE_URL
  },
  methods: {
    sortData(sortKey) {
      this.userLoading = true;
      this.sortKey = sortKey;
      let direction = '';
      if (sortKey == 'last_name') {
        this.sortDateDirection = 0;
        this.sortNameDirection = this.sortNameDirection == 1 ? -1 : 1;
        direction = this.sortNameDirection == 1 ? '' : '-';
      }
      if (sortKey == 'date_joined') {
        this.sortNameDirection = 0;
        this.sortDateDirection = this.sortDateDirection == 1 ? -1 : 1;
        direction = this.sortDateDirection == 1 ? '' : '-';
      }
      let params = '';
      if (this.countryFilter != '') {
        params = '&country=' + this.countryFilter;
      }
      axios.get('/account/admin/users/?order_by=' + direction + sortKey + params)
        .then((response) => {
          if (response.status == '200') {
            this.userList = response.data.data
            this.search = ''
            this.$validator.reset()
            this.userLoading = false
          }
        })
        .catch((err) => {
          this.userLoading = false
        })
    },
    getUserListAgain() {
      this.$store.dispatch('getUserListDetails').then((res) => {}).catch((err) => {})
    },
    addUserFun() {
      this.userCreateform = true
    },
    loadmoreUser(url) {
      this.userLoading = true
      axios.get(url)
        .then((response) => {
          // debugger
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          // console.log(this.loadmoreData, this.nextStep)
          this.$set(this.userList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            // debugger
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.userListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
            // toast.success(this.loadmoreData.msg);
            // this.userList.push(this.loadmoreData)
          }
        });
    },
    validateSearchUserBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.searchData = this.search
          if (this.searchData) {
            this.submitted = true;
            axios.get('/account/admin/users/?name=' + this.searchData)
              .then((response) => {
                if (response.status == '200') {
                  this.userList = response.data.data
                  this.search = ''
                  this.$validator.reset()
                }
              })
              .catch((err) => {})
          }
        }
      })
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/flags/${country.value}.svg`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    showExportAllUser(){
      this.$store.dispatch('getExportUserDetails')
      .then((res) => {
        const type = res.headers['content-type']
        let blob = new Blob([res.data], { type: type })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'file.xls'
        link.click()
      })
      .catch((err) => {})
      return
    },
    userTransferAuthorList(id){
      let data = {
        user : id
      }
      this.$store.dispatch('createAuthorUsersFun', data).then((res) => {
        if (res.status == '200' || res.status == '201') {
          toast.success(res.data.msg);
          this.getUserListAgain()
        }
      }).catch((err) => {})
    }
  },
  beforeMount() {
    this.getUserList;
  },
  watch: {
    getUserList() {
      return this.$store.getters.getuserListDetailsState
    },
    SetIntialStatus() {
      if (this.userList) {
        this.userListResults = this.userList.results
      }
    }
  }
}